import React, { useEffect, useState } from 'react'
import { useRef } from 'react';
import {
    FormGroup, FormControlLabel, Checkbox, Typography, FormLabel, FormControl, RadioGroup, Radio, IconButton
} from "@mui/material";
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import { useNavigate, useLocation } from 'react-router-dom';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import axiosInstance from '../../../lib/axios';
import checkAndLock from "../../../GlobalFunction/checkAndLock";
import axios from "../../../lib/axios";
import UnLock from "../../../GlobalFunction/UnLock";
import CrudButtons from '../../../GlobalFunction/CrudButtons';
import ReportTable from '../../../atoms/ReportFolder/ReportTable';
import { useReactToPrint } from 'react-to-print';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import CustomAutocomplete from '../../../Components/AutoComplete/AutocompletewithoutIcon';
import EnqList from './EnqList';
import CloseIcon from '@mui/icons-material/Close';
import ConfirmationDialog from '../../ReusableDailog';
import moment from 'moment';

const columns = [
    { id: 'RowNum', label: 'S.No.', minWidth: 170 },
    { id: 'VndRtgName', label: 'Vendor Name', minWidth: 100 },
    { id: 'VndRtgAbrv', label: 'Vendor Abrv', minWidth: 100 },
    { id: 'Remark', label: 'Remark', minWidth: 100 }
];

const Visitor = () => {
    const [formData, setFormData] = useState({
        VndRtgName: '',
        VndRtgAbrv: '',
        Occupation: 'S',
        Staying: 'N',
        Remark: '',
        PropId: "",
        EnqNo: "",
        EnqDt: moment().format('DD/MM/YYYY'),
        SourceId: "",
        SourceName: "",
        BrokerId: "",
        EnqType: "",
        EnqBy: "",
        MobileNo: "",
        EmailId: "",
        EnqFor: "",
        Address: "",
        Tenure: "0",
        CheckInDt: moment().format('DD/MM/YYYY'),
        RoomTypeId: "",
        PreviousStayNm: "",
        Remark: "",
        Status: "",
        BookId: "",
        FlwUserId: "",
        VisitSt: "N",
        VisitDt: moment().format('DD/MM/YYYY'),
        VisitUserId: "",
        VisitRemark: "",
        CanlDt: "",
        CanlUserId: "",
        CanlRemark: "",
        CreatedBy: "",
        RelationId: "",
        InstituteId: "",
        NextFlwDt: "",
        SemesterId: "",
        CourseId: "",
        DesiId: "",
        Occupation: "S",
        OcupntMob: '',
        enquiryStatus: 'open',
    });

    const [error, setError] = useState({
        VndRtgName: false,
        VndRtgAbrv: false
    });

    const navigate = useNavigate();
    const [isFormDisabled, setIsFormDisabled] = useState(true);
    const location = useLocation();
    const [currentEnqId, setCurrentEnqId] = useState(null);
    const [mode, setMode] = useState('view');
    const [Status, setStatus] = useState("1");
    const [lastInsertedEnqId, setLastInsertedEnqId] = useState(null);
    const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
    const [UserId, setUserId] = useState(sessionStorage.getItem('UserId'));
    const [DataForPrint, setDataForPrint] = useState({});
    const [rows, setRows] = useState([]);
    const contentRef = useRef(null);
    const handlePrint = useReactToPrint({ contentRef });
    const ratingNameRef = useRef(null);
    const ratingAbrvRef = useRef(null);
    const remarkRef = useRef(null);
    const [institutions, setInstitutions] = useState([]);
    const [course, setCourse] = useState([]);
    const [semester, setSemester] = useState([]);
    const [source, setSource] = useState([]);
    const [parentOcc, setParentOcc] = useState([]);
    const [RoomType, setRoomType] = useState([]);
    const [visitDate, setVisitDate] = useState(dayjs());
    const [checkinDate, setCheckinDate] = useState(dayjs());
    const [openEnq, setOpenEnq] = useState(false);

    useEffect(() => {
        if (location.state && location.state.EnqId) {
            setCurrentEnqId(location.state.EnqId);
            fetchVisitorData(location.state.EnqId);
            setMode('view');
        } else {
            setMode('add');
            setIsFormDisabled(false);
        }
    }, [location]);

    const fetchVisitorData = async (enqId, flag) => {
        try {
            const response = await axiosInstance.post(`TrnEnq/RetriveTrnEnq`, {
                EnqId: parseInt(enqId),
                Flag: "R",
                CreatedBy: UserId
            });

            if (response.data.Status === 0 && response.data.responseStatusCode === 1) {
                const enquiryData = response.data.Data[0];
                setFormData({
                    PropId: enquiryData.PropId.toString() || '',
                    EnqNo: enquiryData.EnqNo || '',
                    EnqDt: enquiryData.EnqDt ? moment(enquiryData.EnqDt).format('DD/MM/YYYY') : '',
                    SourceId: enquiryData.SourceId.toString() || '',
                    SourceName: enquiryData.SourceName || '',
                    BrokerId: enquiryData.BrokerId?.toString() || '',
                    EnqType: enquiryData.EnqType || '',
                    EnqBy: enquiryData.EnqBy || '',
                    MobileNo: enquiryData.MobileNo || '',
                    EmailId: enquiryData.EmailId || '',
                    EnqFor: enquiryData.EnqFor || '',
                    Address: enquiryData.Address || '',
                    Tenure: enquiryData.Tenure || 0,
                    CheckInDt: enquiryData.CheckInDt ? moment(enquiryData.CheckInDt).format('DD/MM/YYYY') : '',
                    RoomTypeId: enquiryData.RoomTypeId.toString() || '',
                    PreviousStayNm: enquiryData.PreviousStayNm || '',
                    Remark: enquiryData.Remark || '',
                    BookId: enquiryData.BookId?.toString() || '',
                    FlwUserId: enquiryData.FlwUserId?.toString() || '',
                    VisitSt: enquiryData.VisitSt || '',
                    VisitDt: enquiryData.VisitDt ? moment(enquiryData.VisitDt).format('DD/MM/YYYY') : '',
                    NextFlwDt: enquiryData.NextFlwDt ? moment(enquiryData.NextFlwDt).format('DD/MM/YYYY') : '',
                    VisitUserId: enquiryData.VisitUserId?.toString() || '',
                    FlwUserId: enquiryData.FlwUserId?.toString() || "",
                    VisitRemark: enquiryData.VisitRemark || '',
                    CanlDt: enquiryData.CanlDt || '',
                    CanlUserId: enquiryData.CanlUserId || '',
                    CanlRemark: enquiryData.CanlRemark || '',
                    RelationId: enquiryData.RelationId?.toString() || '',
                    InstituteId: enquiryData.InstituteId?.toString() || '',
                    SemesterId: enquiryData.SemesterId?.toString() || '',
                    CourseId: enquiryData.CourseId?.toString() || '',
                    DesiId: enquiryData.DesiId.toString() || '',
                    Occupation: enquiryData.Occupation || '',
                    OcupntMob: enquiryData.OcupntMob || ''
                });

                setStatus(enquiryData.Status.toString() || "0");
                setIsFormDisabled(true);
            } else if (response.data.Status === 1 && response.data.responseStatusCode === 2) {
                toast.info(response.data.Message);
            }
        } catch (error) {
            toast.error('Error fetching enquiry data. Please try again.');
        }
    };

    useEffect(() => {
        const getRow = async () => {
            const params = {
                start: 1,
                PageSize: 1,
                SearchText: ""
            };

            try {
                const res = await axios.post('MstVendRating/GetMstVndRtgDashBoard', { params });

                if (res.data && res.data.Data) {
                    setRows(res.data.Data);
                    setDataForPrint(res.data.Data);
                }
            } catch (err) {
                console.error('Error fetching data:', err);
            }
        };

        getRow();
    }, []);

    const handlePrevious = async () => {
        if (currentEnqId && currentEnqId > 1) {
            await fetchVisitorData(currentEnqId, "P");
        }
    };

    const handleNext = async () => {
        if (currentEnqId) {
            await fetchVisitorData(currentEnqId, "N");
        }
    };

    const openEnqDialog = () => {
        setOpenEnq(true);
    };

    const closeEnqDialog = () => {
        setOpenEnq(false);
    };

    useEffect(() => {
        GetInstituteeName();
        GetCourseName();
        GetSemesterName();
        GetSourceName();
        roomType();
    }, []);

    const GetInstituteeName = async () => {
        try {
            const response = await axiosInstance.post(`MstInstitute/getMstInstitutedrp`);
            if (response.data.Status === 0 && response.data.responseStatusCode === 1) {
                setInstitutions(response.data.Data);
            }
        } catch (error) {
            toast.error('Error fetching Institute. Please try again.');
        }
    };

    const GetCourseName = async () => {
        try {
            const response = await axiosInstance.post(`MstCourse/getMstCoursedrp`);
            if (response.data.Status === 0 && response.data.responseStatusCode === 1) {
                setCourse(response.data.Data);
            }
        } catch (error) {
            toast.error('Error fetching Course. Please try again.');
        }
    };

    const GetSemesterName = async () => {
        try {
            const response = await axiosInstance.post(`MstSemester/getMstSemesterdrp`);
            if (response.data.Status === 0 && response.data.responseStatusCode === 1) {
                setSemester(response.data.Data);
            }
        } catch (error) {
            toast.error('Error fetching Semester. Please try again.');
        }
    };

    const roomType = async () => {
        try {
            const response = await axiosInstance.post(`RoomMst/getdrpRoomTypeMst`);
            if (response.data.Status === 0 && response.data.responseStatusCode === 1) {
                setRoomType(response.data.Data);
            }
        } catch (error) {
            toast.error('Error fetching RoomType. Please try again.');
        }
    };

    const GetSourceName = async () => {
        try {
            const response = await axiosInstance.post(`MstSource/getMstSourcedrp`)
            if (response.data.Status === 0 && response.data.responseStatusCode === 1) {
                setSource(response.data.Data)
            }
        } catch (err) {
            toast.error('Error fetching courses:', err);
        }
    };

    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    const handleChangeStatus = (event) => {
        const updatedStatus = event.target.checked ? "1" : "0";
        setStatus(updatedStatus);
    };

    const handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            if (event.target === ratingNameRef.current) {
                ratingAbrvRef.current.focus();
            } else {
                remarkRef.current.focus();
            }
        }
    };

    const handleSubmit = async () => {

        let hasError = false;

        if (!formData.VndRtgName) {
            toast.error('Rating is required');
            setError(prev => ({ ...prev, VndRtgName: true }));
            hasError = true;
        } else {
            setError(prev => ({ ...prev, VndRtgName: false }));
        }

        if (hasError) {
            return;
        }

        try {
            const payload = {
                VndRtgName: formData.VndRtgName,
                VndRtgAbrv: formData.VndRtgAbrv,
                Remark: formData.Remark,
                Status: Status
            };

            let response;
            if (mode === 'edit') {
                payload.EnqId = currentEnqId;
                payload.UpdatedBy = parseInt(UserId, 10);
                response = await axiosInstance.patch(`MstVendRating/UpdateMstVndRtg`, payload);
            } else {
                payload.CreatedBy = parseInt(UserId, 10);
                response = await axiosInstance.post(`MstVendRating/InsertMstVndRtg`, payload);
            }

            if (response.data.Status === 0 && response.data.responseStatusCode === 1) {
                toast.success(response.data.Message);
                if (mode === 'add') {
                    setLastInsertedEnqId(response.data.Data)
                    await fetchVisitorData(response.data.Data);
                    setMode('view');
                    setIsFormDisabled(true);
                    setCurrentEnqId(response.data.Data);
                } else {
                    setMode('view');
                }
                setIsFormDisabled(true);
            } else {
                toast.error(response.data.Message || 'Operation failed');
            }
        } catch (error) {
            toast.error('Error saving/updating Rating. Please try again.');
        }
    };

    const handleEdit = () => {
        setMode("edit");
        setIsFormDisabled(false);
    };

    const handleAdd = () => {
        setMode('add');
        setIsFormDisabled(false);
        setOpenEnq(true);
        setFormData({
            VndRtgName: '',
            VndRtgAbrv: '',
            Occupation: 'S',
            Remark: '',
            PropId: "",
            EnqNo: "",
            EnqDt: moment().format('DD/MM/YYYY'),
            SourceId: "",
            SourceName: "",
            BrokerId: "",
            EnqType: "",
            EnqBy: "",
            MobileNo: "",
            EmailId: "",
            EnqFor: "",
            Address: "",
            Tenure: "0",
            CheckInDt: moment().format('DD/MM/YYYY'),
            RoomTypeId: "",
            PreviousStayNm: "",
            Remark: "",
            Status: "",
            BookId: "",
            FlwUserId: "",
            VisitSt: "N",
            VisitDt: moment().format('DD/MM/YYYY'),
            VisitUserId: "",
            VisitRemark: "",
            CanlDt: "",
            CanlUserId: "",
            CanlRemark: "",
            CreatedBy: "",
            RelationId: "",
            InstituteId: "",
            NextFlwDt: "",
            SemesterId: "",
            CourseId: "",
            DesiId: "",
            Occupation: "S",
            OcupntMob: '',
            enquiryStatus: 'open',
        });
        setCurrentEnqId(null);

        setTimeout(() => {
            ratingNameRef.current.focus();
        }, 0);
    };

    const handleCancel = () => {
        setStatus("1");
        setMode('view');
        setIsFormDisabled(true);
    };

    const resetForm = () => {
        setFormData({
            VndRtgName: '',
            VndRtgAbrv: '',
            Remark: '',
            SourceId: '',
        });
        setCurrentEnqId(null);
        setMode('view');
    };

    const handleExit = () => {
        navigate('/visitor-table')
    }

    const handleDeleteClick = () => {
        setOpenConfirmDialog(true);
    };

    const handleCloseConfirmDialog = () => {
        setOpenConfirmDialog(false);
    };

    const handleConfirmDelete = async () => {
        let Flag = await checkAndLock(currentEnqId, "MstVndRtg", "EnqId");
        switch (Flag) {
            case 0:
                setOpenConfirmDialog(false);
                await fetchVisitorData(currentEnqId, "D");
                await fetchVisitorData(currentEnqId, "N");
                setStatus("1");
                setMode('view');
                setIsFormDisabled(true);
                break;
            case 1: toast.info("Record  Already Locked", { autoClose: 500 });
                break;
            case 2: toast.info("Record Failed To Locked", { autoClose: 500 });
                break;
            default: toast.info("Something Went Wrong", { autoClose: 500 });
        }
    };

    return (
        <>
            <Box className="form-container" sx={{ height: { xs: '700px', sm: '550px' } }}>
                <ToastContainer />
                <Grid container spacing={2} className='form_grid'>
                    <Grid item xs={12} className='form_title'
                        sx={{
                            display: 'flex', alignItems: 'center',
                            justifyContent: 'space-between', marginTop: '20px',
                            flexDirection: { xs: 'column', sm: 'row', md: 'row' }
                        }}
                    >
                        <Grid
                            sx={{
                                display: 'flex',
                                justifyContent: { xs: 'center', sm: 'flex-start' },
                                marginBottom: { xs: '10px', sm: 0 }
                            }}
                        >
                            <Button
                                variant="contained"
                                size="small"
                                className='three-d-button-previous'
                                onClick={handlePrevious}
                                sx={{ backgroundColor: '#635BFF', marginRight: { xs: '5px', sm: '10px' }, display: { xs: 'none', sm: 'block' } }}
                                disabled={mode !== 'view' || !currentEnqId || currentEnqId === 1}
                            >
                                <KeyboardArrowLeftIcon />
                            </Button>

                            <Button
                                variant="contained"
                                size="small"
                                className='three-d-button-next'
                                onClick={handleNext}
                                sx={{ backgroundColor: '#635BFF', display: { xs: 'none', sm: 'block' } }}
                                disabled={mode !== 'view' || !currentEnqId}
                            >
                                <NavigateNextIcon />
                            </Button>
                        </Grid>

                        <Typography
                            variant="h5"
                            sx={{
                                margin: 'Auto',
                                textAlign: { xs: 'center', sm: 'center' },
                                fontSize: { xs: '24px', sm: '18px', md: '24px' }
                            }}
                        >
                            Visitor Entry
                        </Typography>

                        <Grid sx={{ display: "flex", justifyContent: "end" }}>
                            <CrudButtons
                                moduleName={"Rating Master"}
                                mode={mode}
                                onAdd={handleAdd}
                                onEdit={handleEdit}
                                onView={handlePrint}
                                onDelete={handleConfirmDelete}
                                onExit={handleExit}
                                onPrevious={handlePrevious}
                                onNext={handleNext}
                                readOnlyMode={isFormDisabled}
                            />
                        </Grid>
                    </Grid>

                    <Grid item xs={12} className='form_field' sx={{ marginInline: { xs: "0px", sm: "80px" } }}>
                        <Grid container spacing={1}>
                            <Grid item xs={12} md={4} lg={3}>
                                <TextField
                                    id="MobileNo"
                                    name="MobileNo"
                                    label={<span> Visitor Mobile No<span style={{ color: 'red' }}>*</span></span>}
                                    variant="filled"
                                    fullWidth
                                    className="custom-textfield"
                                    onClick={() => setOpenEnq(true)}
                                    placeholder='Enter Mobile No'
                                    value={formData.MobileNo}
                                    onChange={handleInputChange}
                                    disabled={isFormDisabled}
                                    inputRef={ratingNameRef}
                                />
                            </Grid>
                            <Grid item xs={12} md={4} lg={3}>
                                <TextField
                                    id="EnqNo"
                                    name="EnqNo"
                                    label="Enquiry No"
                                    variant="filled"
                                    fullWidth
                                    className="custom-textfield"
                                    placeholder='Enter Enq No'
                                    value={formData.EnqNo}
                                    onChange={handleInputChange}
                                    disabled={isFormDisabled}
                                    inputRef={ratingAbrvRef}
                                />
                            </Grid>
                            <Grid item xs={12} md={4} lg={3}>
                                <TextField
                                    id="VndRtgName"
                                    name="VndRtgName"
                                    label="Visit No"
                                    variant="filled"
                                    fullWidth
                                    className="custom-textfield"
                                    value={formData.VndRtgName}
                                    onChange={handleInputChange}
                                    disabled={true}
                                    inputRef={ratingNameRef}
                                    onKeyDown={handleKeyPress}
                                />
                            </Grid>
                            <Grid item xs={12} md={4} lg={3}>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DatePicker
                                        label="Visit Date"
                                        value={visitDate}
                                        onChange={(newValue) => setVisitDate(newValue)}
                                        format='DD/MM/YYYY'
                                        slotProps={{
                                            textField: { fullWidth: true, variant: 'filled' }
                                        }}
                                        className="custom-textfield"
                                        disabled={isFormDisabled}
                                    />
                                </LocalizationProvider>
                            </Grid>

                            <Grid item xs={12} md={4} lg={6}>
                                <TextField
                                    id="EnqBy"
                                    name="EnqBy"
                                    label={<span>Visitor Name<span style={{ color: 'red' }}>*</span></span>}
                                    variant="filled"
                                    fullWidth
                                    className="custom-textfield"
                                    value={formData.EnqBy}
                                    onChange={handleInputChange}
                                    disabled={isFormDisabled}
                                    inputRef={remarkRef}
                                />
                            </Grid>

                            {/* <Grid item xs={12} md={4} lg={6}>
                                <TextField
                                    id="Remark"
                                    name="Remark"
                                    label={<span>Visitor Contact<span style={{ color: 'red' }}>*</span></span>}
                                    variant="filled"
                                    fullWidth
                                    className="custom-textfield"
                                    value={formData.Remark}
                                    onChange={handleInputChange}
                                    disabled={isFormDisabled}
                                    inputRef={remarkRef}
                                />
                            </Grid> */}

                            <Grid item xs={12} md={4} lg={6}>
                                <TextField
                                    id="EnqBy"
                                    name="EnqBy"
                                    label="Occupant Name"
                                    variant="filled"
                                    fullWidth
                                    className="custom-textfield"
                                    value={formData.EnqBy}
                                    onChange={handleInputChange}
                                    disabled={isFormDisabled}
                                    inputRef={remarkRef}
                                />
                            </Grid>

                            <Grid item xs={12} md={4} lg={6}>
                                <TextField
                                    id="Email"
                                    name="Email"
                                    label="Email"
                                    variant="filled"
                                    fullWidth
                                    className="custom-textfield"
                                    value={formData.Email}
                                    onChange={handleInputChange}
                                    disabled={isFormDisabled}
                                    inputRef={remarkRef}
                                />
                            </Grid>

                            <Grid item xs={12} md={4} lg={6}>
                                <Grid container alignItems="center" spacing={1} sx={{ paddingLeft: '9px' }}>
                                    <Grid item>
                                        <FormLabel component="legend">Student/Working</FormLabel>
                                    </Grid>

                                    <Grid item>
                                        <FormControl component="fieldset">
                                            <RadioGroup
                                                aria-label="Occupation"
                                                name="Occupation"
                                                value={formData.Occupation}
                                                onChange={handleInputChange}
                                                row
                                            >
                                                <FormControlLabel
                                                    value="S"
                                                    control={<Radio sx={{ '& .MuiSvgIcon-root': { fontSize: 18 } }} />}
                                                    label="Student"
                                                    className="custom-textfield"
                                                    disabled={isFormDisabled}
                                                />
                                                <FormControlLabel
                                                    value="W"
                                                    control={<Radio sx={{ '& .MuiSvgIcon-root': { fontSize: 18 } }} />}
                                                    label="Service"
                                                    className="custom-textfield"
                                                    disabled={isFormDisabled}
                                                />
                                            </RadioGroup>
                                        </FormControl>
                                    </Grid>
                                </Grid>
                            </Grid>

                            <Grid item xs={12} md={4} lg={6}>
                                <CustomAutocomplete
                                    id="InstituteId-autocomplete"
                                    name='InstituteId'
                                    label={<span>Institute/Corporate<span style={{ color: 'red' }}>*</span></span>}
                                    options={institutions}
                                    value={institutions.find(InstituteId => InstituteId.Id == formData.InstituteId) || ""}
                                    onChange={handleInputChange}
                                    disabled={isFormDisabled}
                                />
                            </Grid>
                            <Grid item xs={12} md={4} lg={3}>
                                <CustomAutocomplete
                                    id="CourseId-autocomplete"
                                    name='CourseId'
                                    label={<span>Course<span style={{ color: 'red' }}>*</span></span>}
                                    options={course}
                                    value={course.find(CourseId => CourseId.Id == formData.CourseId) || null}
                                    onChange={handleInputChange}
                                    disabled={isFormDisabled}
                                />
                            </Grid>
                            <Grid item xs={12} md={4} lg={3}>
                                <CustomAutocomplete
                                    id="SemesterId-autocomplete"
                                    name='SemesterId'
                                    label={<span>Semester<span style={{ color: 'red' }}>*</span></span>}
                                    options={semester}
                                    value={semester.find(SemesterId => SemesterId.Id == formData.SemesterId) || ""}
                                    onChange={handleInputChange}
                                    disabled={isFormDisabled}
                                />
                            </Grid>
                            <Grid item xs={12} md={4} lg={6}>
                                <Grid container alignItems="center" spacing={1} sx={{ paddingLeft: '9px' }}>
                                    <Grid item>
                                        <FormLabel component="legend">Currently Staying</FormLabel>
                                    </Grid>

                                    <Grid item>
                                        <FormControl component="fieldset">
                                            <RadioGroup
                                                aria-label="Staying"
                                                name="Staying"
                                                value={formData.Staying}
                                                onChange={handleInputChange}
                                                row
                                            >
                                                <FormControlLabel
                                                    value="Y"
                                                    control={<Radio sx={{ '& .MuiSvgIcon-root': { fontSize: 18 } }} />}
                                                    label="Yes"
                                                    className="custom-textfield"
                                                    disabled={isFormDisabled}
                                                />
                                                <FormControlLabel
                                                    value="N"
                                                    control={<Radio sx={{ '& .MuiSvgIcon-root': { fontSize: 18 } }} />}
                                                    label="No"
                                                    className="custom-textfield"
                                                    disabled={isFormDisabled}
                                                />
                                            </RadioGroup>
                                        </FormControl>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item xs={12} md={4} lg={6}>
                                <TextField
                                    id="Remark"
                                    name="Remark"
                                    label="Name of hostel currently staying in"
                                    variant="filled"
                                    fullWidth
                                    className="custom-textfield"
                                    value={formData.Remark}
                                    onChange={handleInputChange}
                                    disabled={isFormDisabled}
                                    inputRef={remarkRef}
                                />
                            </Grid>
                            <Grid item xs={12} md={4} lg={3}>
                                <CustomAutocomplete
                                    id="RoomTypeId-autocomplete"
                                    name='RoomTypeId'
                                    label="Room Type"
                                    options={RoomType}
                                    value={RoomType.find(RoomTypeId => RoomTypeId.Id == formData.RoomTypeId) || null}
                                    onChange={handleInputChange}
                                    disabled={isFormDisabled}
                                />
                            </Grid>
                            <Grid item xs={12} md={4} lg={3}>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DatePicker
                                        label="Expected Checking Date"
                                        value={visitDate}
                                        onChange={(newValue) => setVisitDate(newValue)}
                                        format='DD/MM/YYYY'
                                        slotProps={{
                                            textField: { fullWidth: true, variant: 'filled' }
                                        }}
                                        className="custom-textfield"
                                        disabled={isFormDisabled}
                                    />
                                </LocalizationProvider>
                            </Grid>
                            <Grid item xs={12} md={4} lg={6}>
                                <CustomAutocomplete
                                    id="SourceId-autocomplete"
                                    name='SourceId'
                                    label={<span>How did you hear about Clanbridge Living?<span style={{ color: 'red' }}>*</span></span>}
                                    options={source}
                                    value={source.find(SourceId => SourceId.Id == formData.SourceId) || ""}
                                    onChange={handleInputChange}
                                    disabled={isFormDisabled}
                                />
                            </Grid>
                            <Grid item xs={12} md={4} lg={6}>
                                <TextField
                                    id="Remark"
                                    name="Remark"
                                    label={<span>Father/Mother/Guardian's Name<span style={{ color: 'red' }}>*</span></span>}
                                    variant="filled"
                                    fullWidth
                                    className="custom-textfield"
                                    value={formData.Remark}
                                    onChange={handleInputChange}
                                    disabled={isFormDisabled}
                                    inputRef={remarkRef}
                                />
                            </Grid>
                            <Grid item xs={12} md={4} lg={6}>
                                <CustomAutocomplete
                                    id="SourceId-autocomplete"
                                    name='SourceId'
                                    label={<span>Father/Mother/Guardian's occupation<span style={{ color: 'red' }}>*</span></span>}
                                    options={parentOcc}
                                    value={parentOcc.find(SourceId => SourceId.Id == formData.SourceId) || null}
                                    onChange={handleInputChange}
                                    disabled={isFormDisabled}
                                />
                            </Grid>
                            <Grid item xs={12} md={4} lg={6}>
                                <CustomAutocomplete
                                    id="SourceId-autocomplete"
                                    name='SourceId'
                                    label={<span>Who attend you while visiting<span style={{ color: 'red' }}>*</span></span>}
                                    options={parentOcc}
                                    value={parentOcc.find(SourceId => SourceId.Id == formData.SourceId) || null}
                                    onChange={handleInputChange}
                                    disabled={isFormDisabled}
                                />
                            </Grid>
                            <Grid item xs={12} md={4} lg={6}>
                                <CustomAutocomplete
                                    id="SourceId-autocomplete"
                                    name='SourceId'
                                    label="Lead Potential"
                                    options={parentOcc}
                                    value={parentOcc.find(SourceId => SourceId.Id == formData.SourceId) || null}
                                    onChange={handleInputChange}
                                    disabled={isFormDisabled}
                                />
                            </Grid>
                            <Grid item xs={12} md={4} lg={12}>
                                <TextField
                                    id="Remark"
                                    name="Remark"
                                    label="Purpose Visit"
                                    variant="filled"
                                    fullWidth
                                    className="custom-textfield"
                                    value={formData.Remark}
                                    onChange={handleInputChange}
                                    disabled={isFormDisabled}
                                    inputRef={remarkRef}
                                />
                            </Grid>
                            <Grid item xs={12} md={4} lg={11}>
                                <TextField
                                    id="VisitRemark"
                                    name="VisitRemark"
                                    label="Visit Remark"
                                    variant="filled"
                                    fullWidth
                                    className="custom-textfield"
                                    value={formData.VisitRemark}
                                    onChange={handleInputChange}
                                    disabled={isFormDisabled}
                                    inputRef={remarkRef}
                                />
                            </Grid>

                            <Grid item xs={12} md={6} lg={1}>
                                <FormGroup>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                disabled={isFormDisabled}
                                                checked={Status === "1"}
                                                onChange={handleChangeStatus}
                                            />
                                        }
                                        label="Status"
                                    />
                                </FormGroup>
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid item xs={12} className="form_button">
                        {mode === 'view' && (
                            <>
                                <Button variant="contained" sx={{ mr: 1, background: 'linear-gradient(290deg, #d4d4d4, #ffffff)' }} onClick={handleAdd} disabled>
                                    Submit
                                </Button>
                                <Button variant="contained" sx={{ mr: 1, background: 'linear-gradient(290deg, #a7c5e9, #ffffff)' }} onClick={handleEdit}
                                    disabled
                                >
                                    Cancel
                                </Button>
                            </>
                        )}
                        {(mode === 'edit' || mode === 'add') && (
                            <>
                                <Button variant="contained" sx={{ mr: 1 }} onClick={handleSubmit}>
                                    Submit
                                </Button>
                                <Button variant="contained" sx={{ mr: 1 }} onClick={handleCancel}>
                                    Cancel
                                </Button>
                            </>
                        )}
                    </Grid>
                </Grid>
            </Box>

            <div style={{ display: 'none' }}>
                {Object.keys(DataForPrint).length > 0 && <ReportTable
                    columns={columns}
                    rows={rows}
                    title="Rating Master"
                    contentRef={contentRef}
                    customStyles={{ backgroundColor: '#f5f5f5' }}
                />}
            </div>

            <Dialog open={openEnq} onClose={closeEnqDialog} fullWidth maxWidth="sm" >
                <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', px: 2, py: 1 }}>
                    Search By Name/Mobile No
                    <IconButton onClick={closeEnqDialog}>
                        <CloseIcon color='error' />
                    </IconButton>
                </DialogTitle>

                <DialogContent dividers>
                    <EnqList setOpenEnq={setOpenEnq} />
                </DialogContent>
            </Dialog>

            <ConfirmationDialog
                open={openConfirmDialog}
                onClose={handleCloseConfirmDialog}
                onConfirm={handleDeleteClick}
                title="Delete Confirmation"
                message="Are you sure you want to delete this record?"
            />
        </>
    )
}

export default Visitor;
